@file:Suppress("FunctionName")

package editor.action

import common.dto.Quat
import common.dto.Vec3d
import editor.structure.MutableStructure
import editor.structure.StructureElement
import kotlinx.serialization.Serializable

@Serializable
data class EditorAction(val before: StructureElement? = null, val after: StructureElement? = null) {
    init {
        require(before != null || after != null) { "Either before or after must be set" }
        require(before == null || after == null || before.type == after.type) { "Before and after must be of the same type" }
    }

    fun executeOn(structure: MutableStructure) {
        before?.let { structure.remove(it) }
        after?.let { structure.add(it) }
    }

    fun undoOn(structure: MutableStructure) {
        after?.let { structure.remove(it) }
        before?.let { structure.add(it) }
    }
}

fun PlaceAction(element: StructureElement) = EditorAction(after = element)
fun RemoveAction(element: StructureElement) = EditorAction(before = element)
fun MoveAction(before: StructureElement, newPos: Vec3d) = EditorAction(before = before, after = before.copy(pos = newPos))
fun RotateAction(before: StructureElement, newRot: Quat) = EditorAction(before = before, after = before.copy(rot = newRot))

/**
 * Whenever an action is executed, it is added to the action stack.
 */
val actionStack = mutableListOf<EditorAction>()

/**
 * Whenever an action is undone, it is added to the undo stack.
 *
 * The undo stack is cleared as soon as a new action is executed.
 */
val undoStack = mutableListOf<EditorAction>()